var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid",
    className: "root_5d9a3d2f",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 2C4.89543 2 4 2.89543 4 4V9.20703C4.32228 9.11588 4.65659 9.05337 5 9.02242V4C5 3.44772 5.44772 3 6 3H10V6.5C10 7.32843 10.6716 8 11.5 8H15V16C15 16.5523 14.5523 17 14 17H10.4003C10.2174 17.3578 9.99647 17.6929 9.74284 18H14C15.1046 18 16 17.1046 16 16V7.41421C16 7.01639 15.842 6.63486 15.5607 6.35355L11.6464 2.43934C11.3651 2.15804 10.9836 2 10.5858 2H6ZM14.7929 7H11.5C11.2239 7 11 6.77614 11 6.5V3.20711L14.7929 7ZM5.5 19C7.98528 19 10 16.9853 10 14.5C10 12.0147 7.98528 10 5.5 10C3.01472 10 1 12.0147 1 14.5C1 16.9853 3.01472 19 5.5 19ZM7.85353 14.1465C8.04879 14.3418 8.04879 14.6583 7.85353 14.8536C7.65826 15.0489 7.34168 15.0489 7.14642 14.8536L5.99997 13.7072L5.99997 16.5001C5.99997 16.7762 5.77612 17.0001 5.49997 17.0001C5.22383 17.0001 4.99997 16.7762 4.99997 16.5001L4.99997 13.7072L3.85353 14.8536C3.65826 15.0489 3.34168 15.0489 3.14642 14.8536C2.95116 14.6583 2.95116 14.3418 3.14642 14.1465L5.14642 12.1465C5.19436 12.0986 5.24961 12.0624 5.30858 12.038C5.36666 12.0139 5.43027 12.0005 5.49697 12.0001L5.49997 12.0001L5.50297 12.0001C5.56967 12.0005 5.63328 12.0139 5.69136 12.038C5.74947 12.062 5.80396 12.0975 5.8514 12.1444L5.85392 12.1469L7.85353 14.1465Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/file_upload.f6a445a4b18efdf8b21d2a05937d51d2.svg";
export { ForwardRef as ReactComponent };